<script>
import ButtonIcon from "@/components/molecules/button-icon/index";
import Table from "@/components/molecules/table";

export default {
  name: "ContactInfoCoraproList",
  components: { ButtonIcon, Table },
  props: {
    contacts: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    contactsSorted() {
      return [...this.contacts].sort((a, b) => {
        return a.magasin > b.magasin ? 1 : -1;
      });
    }
  }
};
</script>

<template>
  <div class="c-contact-infos-corapro">
    <ButtonIcon
      :icon-name="isOpen ? 'arrow-down' : 'arrow-right'"
      icon-size="sm"
      link
      icon-position="left"
      icon-color="primary"
      variant="primary"
      icon-color-hover="primary-light"
      no-underline
      size="lg"
      @click="isOpen = !isOpen"
    >
      Consulter la liste des magasins proposant ce service
    </ButtonIcon>
    <div v-show="isOpen">
      <Table
        bordered
        responsive="true"
        size="full"
      >
        <thead>
          <tr>
            <th>Magasin</th>
            <th>Contact</th>
            <th>Télephone</th>
            <th>Téléphone mobile</th>
            <th>Adresse email</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(contact, i) in contactsSorted"
            :key="`contactPro${i}`"
          >
            <td>
              {{ contact.magasin }}
            </td>
            <td>
              {{ contact.prenom_referent }}
              {{ contact.nom_referent }}
            </td>
            <td>
              {{ contact.tel_referent }}
            </td>
            <td>
              {{ contact.mobile_referent }}
            </td>
            <td>
              <a :href="`mailto:${contact.mail_referent}`">
                {{ contact.mail_referent }}
              </a>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/table.scss";
.c-contact-infos-corapro {
  margin-left: calc((100% / 12) * 1);
  margin-right: calc((100% / 12) * 1);
}
</style>
